export enum Stage {
  INFANTIL = 'INFANTIL',
  PRIMARIA = 'PRIMARIA',
  SECUNDARIA = 'SECUNDARIA',
  SECONDARY = 'SECONDARY',
}
